var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.999,
    height: 50,
    viewBox: "0 0 49.999 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5456",
    "data-name": "Group 5456",
    transform: "translate(-500 -360)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "info-circle-Filled_1_",
    d: "M374,2555a25,25,0,1,0,25,25A25.042,25.042,0,0,0,374,2555Z",
    transform: "translate(151 -2195)",
    fill: "#3160d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info-circle-Filled_1_2",
    "data-name": "info-circle-Filled_1_",
    d: "M366.034,2555a17.035,17.035,0,1,0,17.034,17.035A17.063,17.063,0,0,0,366.034,2555Z",
    transform: "translate(158.966 -2187.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info-circle-Filled_1_3",
    "data-name": "info-circle-Filled_1_",
    d: "M374,2555a25,25,0,1,0,25,25A25.041,25.041,0,0,0,374,2555Zm2.5,35a2.5,2.5,0,0,1-5,0v-10a2.5,2.5,0,1,1,5,0Zm-2.5-17.5a2.5,2.5,0,1,1,2.5-2.5A2.508,2.508,0,0,1,374,2572.5Z",
    transform: "translate(151.002 -2194.999)",
    fill: "#3160d4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/aboutUs.feae690baf2d76c9305868ae707d99ed.svg";
export { ForwardRef as ReactComponent };